(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
window.onload = function () {
    new Vue({
        el: '#portfolioSliderSection',
        data: {
            window: {
                width: window.innerWidth,
                height: window.innerHeight
            },
            haveMore: true,
            loaded: true
        },
        props: {
            cases: {
                type: Array,
                default: () => ([])
            },
            tags: {
                type: Array,
                default: () => ([])
            },
            divider: {
                type: Number,
                default: 10
            }
        },
        created: function () {
            this.loadItems();
        },
        mounted: function () {
            this.enableWatchers();
        },
        destroyed: function () {

        },
        methods: {
            enableWatchers: function () {
                this.$watch('cases', function () {
                    Vue.set(this, 'items', []);
                });
                this.$watch('tags', function () {
                    Vue.set(this, 'items', []);
                });
            },
            loadItems: function () {
                let url = 'https://www.altoroslabs.com/api/portfolio/getTagsViaUrl?url=' + window.location.pathname.substring(1);
                // let url = 'https://www.altoroslabs.com/api/portfolio/getTagsViaUrl?url=portfolio/portfolio_highly-scalable-system-for-dna-analysis';

                axios.get(url)
                    .then((resp)=> {
                        this.tags = resp.data[0];
                    })
                    .then(() => {
                        let divider = this.divider;

                        let getetCases = [];

                        let pageTitle = $('.s-header__text-wrap h1').text();


                        this.tags.forEach((tag) => {
                            var uri = 'https://www.altoroslabs.com/api/portfolio/projects?category=' + tag.category_id + '&tag=' + tag.id + '&start=0&divider=' + divider;

                            axios.get(uri)
                                .then((resp)=> {
                                    getetCases = getetCases.concat(resp.data.list);
                                })
                                .then(() => {
                                    this.cases = getetCases;
                                    this.cases = this.cases.filter(function( obj ) {
                                        return obj.page.title !== pageTitle;
                                    });

                                    this.cases = this.remove_Dumplicate_Value(this.cases);
                                })
                                .then(() => {
                                    setTimeout(function () {
                                        $('.s-portfolio-case-slider__slider').slick({
                                            arrows: true,
                                            slidesToShow: 3,
                                            slidesToScroll: 3,
                                            prevArrow: '<div class="prev-btn"><img class="image_svg" src="/assets/images/svg/arrow-slider_rght.svg"></div>',
                                            nextArrow: '<div class="next-btn"><img class="image_svg" src="/assets/images/svg/arrow-slider_rght.svg"></div>',
                                            responsive: [
                                                {
                                                    breakpoint: 992,
                                                    settings: {
                                                        slidesToShow: 2,
                                                        slidesToScroll: 2
                                                    }
                                                },
                                                {
                                                    breakpoint: 600,
                                                    settings: {
                                                        slidesToShow: 1,
                                                        slidesToScroll: 1
                                                    }
                                                }
                                            ]
                                        });
                                    }, 3000)
                                })
                        });


                    })

            },
            remove_Dumplicate_Value: function (myArray) {
                var newArray = [];
                $.each(myArray, function(key, value) {
                    var exists = false;
                    $.each(newArray, function(k, val2) {
                        if(value.id == val2.id){ exists = true };
                    });
                    if(exists == false && value.id != "") { newArray.push(value); }
                });

                return newArray;
            }
        }
    });
}
},{}]},{},[1]);
